import { useSelector } from 'react-redux';
import UploadFile from './UploadFile';
import ReviewFormData from './ReviewFormData';
import constants from '../../../../commonUtils/constants';
import { getValueForObjId, isValidObjectId } from '../../../../commonUtils/string.helper';
import { format } from 'date-fns';


const FileUploadSection = ({navBtnsDisabled, setNavBtnsDisabled}) => {
    // const [progress, setProgress] = useState(50);
    const { uploadData, uploadFile, stepVal, pageLoadData } = useSelector((state) => state.Uploads);
    const { name } = useSelector((state) => state.Auth.user);

    const reviewFormData = [
        { label: 'Source Type:', value: uploadData.sourceType },
        { label: 'Master Project:', value: getValueForObjId(pageLoadData.masterProjects, uploadData.masterProject) },
        { label: 'Project:', value: getValueForObjId(pageLoadData.projects, uploadData.project) },
        { 
            label: uploadData.sourceType === "Channel Partner" ? 'Channel Partner:': 'Vendor Name:',
            value: uploadData.sourceType === "Channel Partner" ? 
                (isValidObjectId(uploadData.channelPartner) ? getValueForObjId(pageLoadData.channelPartners, uploadData.channelPartner) : uploadData.channelPartner) : 
                (isValidObjectId(uploadData.vendor) ? getValueForObjId(pageLoadData.vendors, uploadData.vendor) : uploadData.vendor)
        },
        { label: 'SPOC:', value: getValueForObjId(pageLoadData.users, uploadData.spoc) },
        { label: 'Uploaded By:', value: name },
        { label: 'Data Category:', value: getValueForObjId(pageLoadData.dataCategories, uploadData.dataCategory) },
        { label: 'Lead Source:', value: getValueForObjId(pageLoadData.leadSources, uploadData.leadSource) },
        { label: 'Extracted On:', value: uploadData.extractedOn ? format(uploadData.extractedOn, 'MMMM do yyyy') : "" },
        { label: 'Reason of Procurement:', value: uploadData.procReason }
    ];

    const passData = {
        pending: uploadData.pending,
        file: {
            ...uploadData.file,
            ...uploadFile,
            sizeInMB: uploadData.fileSizeInMB,
            rowCount: uploadData.fileRowCount,
            colCount: uploadData.fileColCount
        }
    }
    return (
        stepVal === 2 ? (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-stretch">
                <div className={`col border border-dashed border-2 border-primary flex justify-center items-center min-h-[${constants.upload.cardHeight}]`}>
                    <UploadFile navBtnsDisabled={navBtnsDisabled} setNavBtnsDisabled={setNavBtnsDisabled} />
                </div>
                <div className="col">
                    <ReviewFormData reviewFormData={reviewFormData} data={passData}/>
                </div>
            </div>
        ) : null
    );
};

export default FileUploadSection;
